import React, { useEffect, useState } from 'react';
import './UserTests.css';
import { useHistory } from 'react-router-dom';
import { Button } from '@material-ui/core';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import YouTubeIcon from '@material-ui/icons/YouTube';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import technology from '../../assets/technology.svg';
import QuizCard from '../../components/QuizCard/QuizCard';
import { selectedTestaction } from "../../actions/testActions";
import { useDispatch, useSelector } from 'react-redux';
import UserNav from '../../components/UserNav';
import config from '../../config';

function UserTests() {
	const history = useHistory();
	const dispatch = useDispatch();
	const user = useSelector(state => state.auth.user);
	const [attempts, setAttempts] = useState([]);

	useEffect(() => {
		if (user && user.email) {
			fetch(`${config.API_BASE}/results/${user.email}`)
				.then(res => res.json())
				.then(data => setAttempts(data))
				.catch(err => console.error('Error fetching attempts:', err));
		}
	}, [user]);

	const getAttemptCount = (testType) => {
		console.log('Getting attempt count for:', testType);
		console.log('Available attempts:', attempts);
		
		// Normalize test types for comparison
		const normalizedTestType = testType.toLowerCase().replace(' test', '');
		const filteredAttempts = attempts.filter(a => {
			const normalizedAttemptType = a.testType.toLowerCase();
			console.log('Comparing:', normalizedAttemptType, 'with', normalizedTestType);
			
			// Special case for Learning Strategy Test
			if (testType === "Learning Strategy Test") {
				return normalizedAttemptType === "learning" || 
					   normalizedAttemptType === "learning strategy" ||
					   normalizedAttemptType === "strategy" ||
					   normalizedAttemptType === "learningstrategy";
			}
			
			return normalizedAttemptType === normalizedTestType || 
				   normalizedAttemptType === normalizedTestType.replace('strategy', '') ||
				   normalizedAttemptType === normalizedTestType.replace('interactivity', 'interactive');
		});
		
		console.log('Filtered attempts:', filteredAttempts);
		return filteredAttempts.length;
	};

	const getButtonText = (testType) => {
		const count = getAttemptCount(testType);
		console.log(`Button text for ${testType}: count=${count}`);
		if (count === 0) return 'TAKE TEST';
		return 'RE-TAKE TEST';
	};

	const handleLogout = () => {
		dispatch({ type: 'SET_USER', payload: null });
		localStorage.removeItem('user');
		history.push('/login');
	};

	const handleTestSelect = (test) => {
		// Store the selected test in localStorage and Redux
		localStorage.setItem('selectedTest', JSON.stringify({ title: test }));
		dispatch(selectedTestaction(test));
		
		// Navigate to the test page
		history.replace('/test');
	};

	return (
		<div className="home">
			<UserNav />
			<div className="home__header" style={{ display: 'flex', justifyContent: 'center', marginBottom: 24 }}>
				<div style={{
					background: '#fff',
					boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
					borderRadius: 12,
					padding: '16px 32px',
					display: 'flex',
					alignItems: 'center',
					gap: 16,
					minWidth: 350
				}}>
					<AccountCircleIcon style={{ fontSize: 40, color: '#1A237E' }} />
					<div style={{ flex: 1 }}>
						<div style={{ fontWeight: 700, fontSize: 18, color: '#1A237E' }}>{user?.name || user?.email}</div>
						<div style={{ fontSize: 14, color: '#333' }}>{user?.email}</div>
					</div>
					<Button onClick={() => history.push('/profile')} className="home__profile" style={{ marginLeft: 12 }}>
						Profile
					</Button>
					<Button onClick={handleLogout} className="home__logout" style={{ marginLeft: 8 }}>
						Logout
					</Button>
				</div>
			</div>
			<div className="home__container">
				{/* <div className="home__title">Welcome to the Test Portal</div> */}
				<div className="home__subtitle">
					Choose a test to begin:
				</div>
			</div>
			<div id="cards" className="home__cards">
				<QuizCard
					onClick={() => handleTestSelect("Media Test")}
					className="home__card"
					title="Media Test"
					vector={technology}
					description="Test your media preferences."
					buttonText={getButtonText("Media Test")}
				/>
				<QuizCard
					onClick={() => handleTestSelect("Learning Strategy Test")}
					className="home__card"
					title="Learning Strategy Test"
					vector={technology}
					description="Discover your learning strategy."
					buttonText={getButtonText("Learning Strategy Test")}
				/>
				<QuizCard
					onClick={() => handleTestSelect("Interactivity Test")}
					className="home__card"
					title="Interactivity Test"
					vector={technology}
					description="Find out your interactivity style."
					buttonText={getButtonText("Interactivity Test")}
				/>
			</div>
			<footer className="home__footer">
				<div className="home__footer__copy">Copyright &copy; 2026 intellAdapt</div>
				<div className="home__footer__social">
					<a href="https://www.facebook.com/intelladapt" target="_blank" rel="noopener noreferrer">
						<FacebookIcon className="home__footer__socialIcon" />
					</a>
					<a href="https://twitter.com/intellADAPT" target="_blank" rel="noopener noreferrer">
						<TwitterIcon className="home__footer__socialIcon" />
					</a>
					<a href="https://www.youtube.com/channel/UC32UTPjMhG0tKz25jspcKIQ" target="_blank" rel="noopener noreferrer">
						<YouTubeIcon className="home__footer__socialIcon" />
					</a>
					<a href="https://www.linkedin.com/company/5346214" target="_blank" rel="noopener noreferrer">
						<LinkedInIcon className="home__footer__socialIcon" />
					</a>
				</div>
			</footer>
		</div>
	);
}

export default UserTests;
